import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SubmissionFocusBanner } from './SubmissionFocusBanner';
import { showEnvBanner } from '../EnvironmentBanner';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className={`${showEnvBanner ? 'h-[calc(100vh-32px)]' : 'h-screen'} flex overflow-hidden bg-[#F5F5F5]`}>
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto px-6 pt-4 pb-6">
          <SubmissionFocusBanner />
          {children}
        </main>
      </div>
    </div>
  );
}
